/**************************************************
 * Nombre:       Tarjeta_Categorias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import CountUp from 'react-countup';

const Tarjeta_Indicadores = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                transition: 'all .2s ease-in-out',
                borderRadius: 4,
                border: 1,
                borderColor: '#ffffff60',
                background: 'rgba(255, 255, 255, 0.32)',
                backdropFilter: 'blur(2px)',
                p: 2,
                color: '#fff',
                cursor: 'pointer',
                height: 130
            }}
            spacing={1}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: 28, fontWeight: 800}}><CountUp enableScrollSpy end={item.numero}/> +</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', px: 4}}>
                <Typography sx={{fontSize: 16, fontWeight: 600, textAlign: 'center', lineHeight: 1.2}}>{item.nombre}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Indicadores